import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";

import paymentDataService from "../../services/payment.service";
import balanceDataService from "../../services/balance.service";

const PaymentList = () => {
    const [payments, setPayments] = useState([]);
    const [unprocessedCount, setUnprocessedCount] = useState(0);
    const [userBalance, setUserBalance] = useState([]);
    const [currentPayment, setCurrentPayment] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(-1);
    const [searchPayment, setSearchPayment] = useState("");

    const [genBtnText, setGenBtnText] = useState("Generate Balance");
    // const [showBtnText, setShowBtnText] = useState("Show Balance");

    let navigate = useNavigate();

    useEffect(() => {
        retrievePayments();
        retrieveUnprocessedCount();

        function updateButtonText() {
            if (window.innerWidth < 768) {
                setGenBtnText("Generate Balance");
                // setShowBtnText("Show");
            } else {
                setGenBtnText("Generate Balance");
                // setShowBtnText("Show Balance");
            }
        }

        updateButtonText();

        window.addEventListener("resize", updateButtonText);
        return () => {
            window.removeEventListener("resize", updateButtonText);
        };
    }, []);

    const dialog = useRef(null);

    const openDialog = () => {
        dialog.current.showModal();
    };

    const closeDialog = () => {
        dialog.current.close();
    };

    const handleDoubleClick = () => {
        navigate("/payments/" + currentPayment.id);
    };

    const onChangeSearchPayment = (e) => {
        const searchPayment = e.target.value;
        setSearchPayment(searchPayment);
    };

    const retrievePayments = () => {
        paymentDataService
            .getAll()
            .then((response) => {
                setPayments(response.data);
                console.log(response.data);
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const retrieveUnprocessedCount = () => {
        paymentDataService
            .getCount()
            .then((response) => {
                setUnprocessedCount(parseInt(Object.values(response.data[0])));
                console.log(parseInt(Object.values(response.data[0])));
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const refreshList = () => {
        retrievePayments();
        setCurrentPayment(null);
        setCurrentIndex(-1);
        retrieveUnprocessedCount();
    };

    const setActivePayment = (payment, index) => {
        setCurrentPayment(payment);
        setCurrentIndex(index);
    };

    const removeAllPayments = () => {
        paymentDataService
            .removeAll()
            .then((response) => {
                console.log(response.data);
                refreshList();
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const findByName = () => {
        paymentDataService
            .findByName(searchPayment)
            .then((response) => {
                setPayments(response.data);
                console.log(response.data);
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const retrieveUserBalance = () => {
        balanceDataService
            .getAll()
            .then((response) => {
                setUserBalance(response.data);
                console.log(response.data);
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const showBalance = () => {
        retrieveUserBalance();
        openDialog();
    };

    return (
        <div className="row">
            <nav className="navbar bg-body-tertiary module-nav">
                <div className="container-fluid">
                    <div className="nav-item">
                        <Link
                            to={"/payments/add"}
                            className="m-1 btn btn-sm btn-success"
                        >
                            Add
                        </Link>

                        {/* <button
                            className="m-1 btn btn-sm btn-danger"
                            onClick={removeAllPayments}
                        >
                            Remove All
                        </button> */}

                        <button
                            className="m-1 btn btn-sm btn-warning"
                            onClick={() => {
                                navigate("/payments/" + currentPayment.id);
                            }}
                            disabled={!currentPayment}
                        >
                            Edit
                        </button>

                        <button
                            id="genBalance"
                            className="m-1 btn btn-sm btn-primary position-relative"
                            onClick={() => {
                                if (unprocessedCount !== 0) {
                                    balanceDataService
                                        .create()
                                        .then((response) => {
                                            console.log(response.data);
                                            setUnprocessedCount(0);
                                            refreshList();
                                            showBalance();
                                        })
                                        .catch((e) => {
                                            console.log(e);
                                        });
                                } else {
                                    showBalance();
                                }
                            }}
                            // disabled={unprocessedCount === 0}
                        >
                            {genBtnText}
                            {unprocessedCount > 0 && (
                                <span className="position-absolute top-0 start-100 translate-middle badge bg-danger">
                                    {unprocessedCount}
                                    <span className="visually-hidden">
                                        unread messages
                                    </span>
                                </span>
                            )}
                        </button>

                        {/* <button */}
                        {/* id="showBalance" */}
                        {/* className="m-1 btn btn-sm btn-secondary" */}
                        {/* onClick={() => { */}
                        {/* showBalance(); */}
                        {/* }} */}
                        {/* > */}
                        {/* {showBtnText} */}
                        {/* </button> */}

                        <dialog className="custom-dialog" ref={dialog}>
                            <table className="table">
                                {/* <thead>
                                    <tr>
                                        <th>username</th>
                                        <th>balance</th>
                                    </tr>
                                </thead> */}
                                <tbody>
                                    {userBalance &&
                                        userBalance.map((user, index) => (
                                            <tr
                                                key={index}
                                                style={{
                                                    userSelect: "none",
                                                    color: "rgba(15, 125, 250, 0.85)",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                <th>{user.username}</th>
                                                <td
                                                    style={
                                                        parseFloat(user.sum) < 0
                                                            ? { color: "red" }
                                                            : { color: "green" }
                                                    }
                                                >
                                                    {/* € {user.sum}
                                                    {" -> "}
                                                    {parseFloat(user.sum) < 0
                                                        ? "debit"
                                                        : "credit"} */}
                                                    {parseFloat(user.sum) <
                                                    0 ? (
                                                        `€ ${user.sum} -> debit`
                                                    ) : parseFloat(user.sum) >
                                                      0 ? (
                                                        `€ ${user.sum} -> credit`
                                                    ) : (
                                                        <i class="bi bi-check-circle" />
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>

                            <button
                                className="m-1 btn btn-sm btn-outline-secondary"
                                onClick={() => {
                                    closeDialog();
                                }}
                            >
                                <i className="bi bi-arrow-left-square" /> Back
                            </button>
                        </dialog>
                    </div>

                    <form className="d-flex" role="search">
                        <div className="input-group">
                            <button
                                className="btn btn-outline-secondary"
                                onClick={() => {
                                    searchPayment = "";
                                }}
                            >
                                <i className="bi bi-eraser"></i>
                            </button>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Recipient..."
                                value={searchPayment}
                                onChange={onChangeSearchPayment}
                            />
                            <button
                                className="btn btn-outline-primary"
                                type="button"
                                onClick={findByName}
                            >
                                Search
                            </button>
                        </div>
                    </form>
                </div>
            </nav>

            <div className="col-md-10 module-table">
                <h4 className="page-title">Payments</h4>

                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">date</th>
                            <th scope="col">recipient</th>
                            <th scope="col">amount(€)</th>
                            <th scope="col">paid by</th>
                            <th scope="col">status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {payments &&
                            payments.map((payment, index) => (
                                <tr
                                    className={
                                        index === currentIndex
                                            ? "table-primary"
                                            : ""
                                    }
                                    onClick={() =>
                                        setActivePayment(payment, index)
                                    }
                                    onDoubleClick={handleDoubleClick}
                                    key={index}
                                    style={{ userSelect: "none" }}
                                >
                                    <th scope="row">{index + 1}</th>
                                    <td>
                                        {new Date(
                                            payment.date
                                        ).toLocaleDateString("it-IT")}
                                    </td>
                                    <td>{payment.recipient_name}</td>
                                    <td>{payment.amount}</td>
                                    <td>{payment.paid_by}</td>
                                    <td>
                                        {payment.processed ? (
                                            <span className="badge text-bg-success">
                                                <i className="bi bi-check-circle" />{" "}
                                                Processed
                                            </span>
                                        ) : (
                                            <span className="badge text-bg-warning">
                                                <i className="bi bi-exclamation-circle" />{" "}
                                                Pending
                                            </span>
                                        )}
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>

            <div className="col-md-2 module-detail">
                {currentPayment ? (
                    <div className="inner-detail">
                        <h5>Detail</h5>
                        <div>
                            <label>
                                <strong>Payment date:</strong>
                            </label>{" "}
                            {new Date(currentPayment.date).toDateString()}
                        </div>
                        <div>
                            <label>
                                <strong>Recipient:</strong>
                            </label>{" "}
                            {currentPayment.recipient_name}
                        </div>
                        <div>
                            <label>
                                <strong>Amount(€):</strong>
                            </label>{" "}
                            {currentPayment.amount}
                        </div>
                        <div>
                            <label>
                                <strong>Paid by:</strong>
                            </label>{" "}
                            {currentPayment.paid_by}
                        </div>
                        <div>
                            <label>
                                <strong>Payment type:</strong>
                            </label>{" "}
                            {currentPayment.type}
                        </div>
                        <div>
                            <label>
                                <strong>Notes:</strong>
                            </label>{" "}
                            {currentPayment.notes || "..."}
                        </div>
                        <div>
                            <label>
                                <strong>Processed:</strong>
                            </label>{" "}
                            {currentPayment.processed ? "Yes" : "No"}
                        </div>
                        <div>
                            <label>
                                <strong>Created at:</strong>
                            </label>{" "}
                            {new Date(currentPayment.createdAt).toDateString()}
                        </div>
                        <div>
                            <label>
                                <strong>Updated at:</strong>
                            </label>{" "}
                            {new Date(currentPayment.updatedAt).toDateString()}
                        </div>
                    </div>
                ) : (
                    <div>
                        <p>Please click on a Payment...</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PaymentList;
